module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 45
// module chunks = 0